import React, {useEffect, useState} from 'react';
import BadgeCore from './BadgeCore';

export default function ContinueToGiveBadgeWithDescription({value}) {
  return <BadgeCore value={value} type="show_donation_badge_with_description" />;
}
